var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Jampay")]),_c('p',[_vm._v("Welcome to Jampay! Your registration was successful. You can close this window safely.")])])])
}]

export { render, staticRenderFns }